import { Spin } from "antd"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { classNames } from "../../../utils/classNames"

type Props = {
    size?: "small" | "default" | "large"
    opacity?: number
    caption?: Maybe<string>
    className?: string
}

/**
 * Loading overlay that fills parent 100% width and height.
 * Make sure the parent element has `position: "relative"` attribute.
 */
export const LoadingOverlay = ({ size = "large", opacity = 1, caption, className }: Props) => {
    return (
        <div
            className={classNames(classes.loadingWrap, className)}
            style={{ backgroundColor: `rgba(255,255,255,${opacity})` }}>
            <Spin size={size} />
            {caption ? <div className={classes.loadingLabel}>{caption}</div> : null}
        </div>
    )
}

const classes = {
    loadingWrap: "absolute inset-0 flex flex-col items-center justify-center pt-3 z-[100]",
    loadingLabel: "mt-2 text-14 text-black/70",
}
